"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.strokeInstruction = exports.fillInstruction = exports["default"] = exports.closePathInstruction = exports.beginPathInstruction = void 0;

/**
 * @module ol/render/canvas/Instruction
 */

/**
 * @enum {number}
 */
var Instruction = {
  BEGIN_GEOMETRY: 0,
  BEGIN_PATH: 1,
  CIRCLE: 2,
  CLOSE_PATH: 3,
  CUSTOM: 4,
  DRAW_CHARS: 5,
  DRAW_IMAGE: 6,
  END_GEOMETRY: 7,
  FILL: 8,
  MOVE_TO_LINE_TO: 9,
  SET_FILL_STYLE: 10,
  SET_STROKE_STYLE: 11,
  STROKE: 12
};
/**
 * @type {Array<Instruction>}
 */

var fillInstruction = [Instruction.FILL];
/**
 * @type {Array<Instruction>}
 */

exports.fillInstruction = fillInstruction;
var strokeInstruction = [Instruction.STROKE];
/**
 * @type {Array<Instruction>}
 */

exports.strokeInstruction = strokeInstruction;
var beginPathInstruction = [Instruction.BEGIN_PATH];
/**
 * @type {Array<Instruction>}
 */

exports.beginPathInstruction = beginPathInstruction;
var closePathInstruction = [Instruction.CLOSE_PATH];
exports.closePathInstruction = closePathInstruction;
var _default = Instruction;
exports["default"] = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJtYXBwaW5ncyI6Ijs7Ozs7OztBQUFBOzs7O0FBSUE7OztBQUdBLElBQU1BLFdBQVcsR0FBRztFQUNsQkMsY0FBYyxFQUFFLENBREU7RUFFbEJDLFVBQVUsRUFBRSxDQUZNO0VBR2xCQyxNQUFNLEVBQUUsQ0FIVTtFQUlsQkMsVUFBVSxFQUFFLENBSk07RUFLbEJDLE1BQU0sRUFBRSxDQUxVO0VBTWxCQyxVQUFVLEVBQUUsQ0FOTTtFQU9sQkMsVUFBVSxFQUFFLENBUE07RUFRbEJDLFlBQVksRUFBRSxDQVJJO0VBU2xCQyxJQUFJLEVBQUUsQ0FUWTtFQVVsQkMsZUFBZSxFQUFFLENBVkM7RUFXbEJDLGNBQWMsRUFBRSxFQVhFO0VBWWxCQyxnQkFBZ0IsRUFBRSxFQVpBO0VBYWxCQyxNQUFNLEVBQUU7QUFiVSxDQUFwQjtBQWdCQTs7OztBQUdPLElBQU1DLGVBQWUsR0FBRyxDQUFDZCxXQUFXLENBQUNTLElBQWIsQ0FBeEI7QUFFUDs7Ozs7QUFHTyxJQUFNTSxpQkFBaUIsR0FBRyxDQUFDZixXQUFXLENBQUNhLE1BQWIsQ0FBMUI7QUFFUDs7Ozs7QUFHTyxJQUFNRyxvQkFBb0IsR0FBRyxDQUFDaEIsV0FBVyxDQUFDRSxVQUFiLENBQTdCO0FBRVA7Ozs7O0FBR08sSUFBTWUsb0JBQW9CLEdBQUcsQ0FBQ2pCLFdBQVcsQ0FBQ0ksVUFBYixDQUE3Qjs7ZUFFUUosVyIsIm5hbWVzIjpbIkluc3RydWN0aW9uIiwiQkVHSU5fR0VPTUVUUlkiLCJCRUdJTl9QQVRIIiwiQ0lSQ0xFIiwiQ0xPU0VfUEFUSCIsIkNVU1RPTSIsIkRSQVdfQ0hBUlMiLCJEUkFXX0lNQUdFIiwiRU5EX0dFT01FVFJZIiwiRklMTCIsIk1PVkVfVE9fTElORV9UTyIsIlNFVF9GSUxMX1NUWUxFIiwiU0VUX1NUUk9LRV9TVFlMRSIsIlNUUk9LRSIsImZpbGxJbnN0cnVjdGlvbiIsInN0cm9rZUluc3RydWN0aW9uIiwiYmVnaW5QYXRoSW5zdHJ1Y3Rpb24iLCJjbG9zZVBhdGhJbnN0cnVjdGlvbiJdLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvcmVuZGVyL2NhbnZhcy9JbnN0cnVjdGlvbi5qcyJdLCJzb3VyY2VzQ29udGVudCI6W251bGxdfQ==